import React, { useContext, useEffect, useState, useRef } from "react";
import { Form, Row } from "react-bootstrap";
import SmuUserIcon from "../../utils/smu-user-icon/SmuUserIcon";
import SmuModal from "../../utils/smu-modal/SmuModal";
import { COLOR_PRIMARY } from "../../constants/colors";
import SmuProfilePhotoEditor from "../../utils/smu-profile-photo-editor/SmuProfilePhotoEditor";
import loadingGif from "../../assets/images/loading.gif";
import { StoreContext } from "../../store/StoreContext";

const profiles = [
  {
    id: 1,
    title: "Admin",
  },
  {
    id: 2,
    title: "Usuario",
  },
];

const userTypes = [
  {
    id: "LDAP",
    title: "LDAP",
  },
  {
    id: "Local",
    title: "Local",
  },
];

const editorStyles = { height: 120, width: 120 };

const EditUser = ({ user, onHide, editUser, stores, userStores }) => {
  const iconStyle = { height: 48, width: 48, borderRadius: 12 };
  const dropdownRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [userType, setUserType] = useState("LDAP");
  const [password, setPassword] = useState("");
  const [profileId, setProfileId] = useState(0);
  const [file, setFile] = useState("");
  const [selectedStores, setSelectedStores] = useState([]);
  const [storeSearchTerm, setStoreSearchTerm] = useState('');
  const [isStoreDropdownOpen, setIsStoreDropdownOpen] = useState(false);

  useEffect(() => {
    if (!user) {
      setName("");
      setProfileId("");
      setPassword("");
      setUserType("LDAP");
      setSelectedStores([]);
      return;
    }

    setName(user?.name || user?.username);
    setPassword("");
    setUserType(user?.user_type || "LDAP");
    setProfileId((user.admin == true || user.admin == 'true') ? 1 : 2);
    const preselected = userStores
      .filter((s) => s.idUsuario == user.email)
      .map((s) => s.idTiendas);
    setSelectedStores(preselected);
    setStoreSearchTerm('');
    setIsStoreDropdownOpen(false);
  }, [user]);

  useEffect(() => {
    if (profileId == 1) {
      if (selectedStores.length > 0) {
        setSelectedStores([]);
      }
      setStoreSearchTerm('');
      setIsStoreDropdownOpen(false);
    }
  }, [profileId, selectedStores]);

  const filteredStores = stores.filter(s => {
    const normalizedStoreCode = parseInt(s.codLocal).toString().padStart(4, '0');
    const searchTerm = storeSearchTerm.toLowerCase();
    
    if (/^\d+$/.test(storeSearchTerm)) {
      // For numeric searches, check both the original search term and the padded version
      const originalNumericTerm = storeSearchTerm;
      const paddedSearchTerm = parseInt(storeSearchTerm).toString().padStart(4, '0');
      
      return normalizedStoreCode.includes(originalNumericTerm) ||
             normalizedStoreCode.includes(paddedSearchTerm);
    }
    
    return s.descripcion.toLowerCase().includes(searchTerm);
  });

  const handleStoreSelect = (storeId) => {
    setSelectedStores((prev) => (prev.includes(storeId) ? prev : [...prev, storeId]));
    setStoreSearchTerm('');
    setIsStoreDropdownOpen(false);
  };

  const handleRemoveStore = (storeId) => {
    setSelectedStores((prev) => prev.filter((id) => id !== storeId));
  };

  const getSelectedStoreDisplay = () => {
    return 'Seleccionar Tienda';
  };

  const handleEdit = (event) => {
    event.preventDefault();
    if (!profileId) return;

    setLoading(true);
    const newUser = new FormData();

    newUser.append("username", user.email);
    newUser.append("name", name);
    newUser.append("status", 1);
    newUser.append("password", btoa(encodeURI(password)))
    newUser.append("user_type", userType);
    newUser.append("admin", profileId == 1);
    newUser.append("store", selectedStores[0] || 0);
    newUser.append("formato", process.env.REACT_APP_BRAND);
    newUser.append("idUsuario", user.email);
    (selectedStores || []).forEach((id) => newUser.append("idTiendas", id));
    if (!!file) {
      newUser.append("avatar", file, file.name);
      newUser.append("is_public", true);
    }

    editUser(newUser).finally(() => {
      setLoading(false);
      setName("");
      setPassword("");
      setProfileId("");
      setFile("");
      setUserType("LDAP");
      setSelectedStores([]);
      setStoreSearchTerm('');
      setIsStoreDropdownOpen(false);
      onHide();
    });
  };

  return (
    <SmuModal
      show={Boolean(user)}
      onHide={onHide}
      contentTitle={
        <div className="d-flex align-items-center">
          <SmuUserIcon color={COLOR_PRIMARY} styles={iconStyle} />
          <div className="ms-3 fs-5 text-truncate">Perfil usuario</div>
        </div>
      }
    >
      <div className="my-5 d-flex">
        <SmuProfilePhotoEditor
          styles={editorStyles}
          avatar={user?.avatar}
          file={file}
          setFile={setFile}
        />
      </div>

      <div className="fs-6 mb-3">Dato del perfil</div>

      <Form
        id="edit-user"
        className="smu-form pb-5"
        onSubmit={(event) => handleEdit(event)}
      >
        <Row>
          <Form.Group className="col-6">
            <Form.Control
              type="text"
              className="text-dark"
              value={name}
              onChange={({ target }) => setName(target.value)}
            />
          </Form.Group>
          <Form.Group className="col-6">
            <Form.Select
              type="text"
              className="text-dark"
              value={profileId}
              onChange={({ target }) => setProfileId(Number(target.value))}
            >
              {profiles.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.title}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Row>
        <Row className="mt-4">
          <Form.Group className="col-6">
            <Form.Label htmlFor="passwd">Contraseña</Form.Label>
            <Form.Control
              type="password"
              id="passwd"
              disabled={userType==="LDAP"}
              className="text-dark"
              value={password}
              onChange={({ target }) => setPassword(target.value)}
            />
          </Form.Group>
          <Form.Group className="col-6">
          <Form.Label htmlFor="userType">Tipo de Usuario</Form.Label>
            <Form.Select
              type="text"
              id="userType"
              className="text-dark"
              value={userType}
              onChange={e => setUserType(e.target.value)}
            >
              {userTypes.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.title}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Row>
        <Row className="mt-4">
          <Form.Group className="col-6">
            <Form.Label htmlFor="store">Tiendas asignadas {profileId == 2 ? "*" : ""}</Form.Label>
            {selectedStores.length > 0 && (
              <div className="d-flex flex-wrap gap-2 mb-2">
                {selectedStores.map((id) => {
                  const s = stores.find((st) => st.idTiendas == id);
                  const label = s ? parseInt(s.codLocal).toString().padStart(4, '0') : id;
                  return (
                    <span key={id} className="border rounded px-2 py-1 d-flex align-items-center" style={{ fontSize: '12px', gap: '8px' }}>
                      {label}
                      <span role="button" aria-label="Quitar tienda" style={{ cursor: 'pointer' }} onClick={() => handleRemoveStore(id)}>×</span>
                    </span>
                  );
                })}
              </div>
            )}
            <div className="position-relative">
              <Form.Control
                type="text"
                id="store"
                className="text-dark"
                placeholder={getSelectedStoreDisplay()}
                value={isStoreDropdownOpen ? storeSearchTerm : getSelectedStoreDisplay()}
                onChange={(e) => {
                  setStoreSearchTerm(e.target.value);
                  setIsStoreDropdownOpen(true);
                }}
                onFocus={() => setIsStoreDropdownOpen(true)}
                onBlur={(e) => {
                  // Check if the focus is moving to an element within the dropdown
                  if (dropdownRef.current && dropdownRef.current.contains(e.relatedTarget)) {
                    return; // Don't close the dropdown
                  }
                  setTimeout(() => setIsStoreDropdownOpen(false), 200);
                }}
                autoComplete="off"
                disabled={profileId == 1}
              />
              {isStoreDropdownOpen && (
                <div 
                  ref={dropdownRef}
                  className="position-absolute w-100 bg-white border border-secondary rounded mt-1" 
                  style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto' }}
                  onMouseDown={(e) => {
                    // Prevent the dropdown from closing when clicking on scrollbar
                    const rect = e.currentTarget.getBoundingClientRect();
                    const scrollbarWidth = 17; // Approximate scrollbar width
                    const isClickingOnScrollbar = e.clientX > rect.right - scrollbarWidth;
                    
                    if (isClickingOnScrollbar) {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  }}
                >
                  {selectedStores.length > 0 && (
                    <div 
                      className="px-3 py-2 cursor-pointer border-bottom"
                      style={{ cursor: 'pointer' }}
                      onMouseDown={() => setSelectedStores([])}
                    >
                      Limpiar selección
                    </div>
                  )}
                  {filteredStores.map((s) => (
                    <div
                      key={s.idTiendas}
                      className="px-3 py-2 cursor-pointer border-bottom"
                      style={{ cursor: 'pointer' }}
                      onMouseDown={() => handleStoreSelect(s.idTiendas)}
                    >
                      {parseInt(s.codLocal).toString().padStart(4, '0')}
                    </div>
                  ))}
                  {filteredStores.length === 0 && storeSearchTerm && (
                    <div className="px-3 py-2 text-muted">
                      No se encontraron tiendas
                    </div>
                  )}
                </div>
              )}
            </div>
          </Form.Group>
        </Row>
      </Form>

      <div className="d-flex mb-3 mt-5">
        {!loading ? (
          <button
            form="edit-user"
            type="submit"
            disabled={selectedStores.length === 0 && profileId == 2} // Si es usuario y estoy editando, no se puede guardar sin antes indicar una o más tiendas
            className="ms-auto smu-generic-button solid-btn py-1"
          >
            Guardar
          </button>
        ) : (
          <div className="ms-auto smu-generic-button solid-btn py-1 px-5">
            <img
              src={loadingGif}
              alt="Cargando"
              className="m-auto"
              width={20}
              height={20}
            />
          </div>
        )}
      </div>
    </SmuModal>
  );
};

export default EditUser;
